var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBadgesPathwayBackgroundLeft26 = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    viewBox: "0 0 1145.22 2039.71",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;fill-rule:evenodd;opacity:.31;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M151,3s-1.93,102.1-23,170c-21.07,67.9-21.33,143.57,40,244,61.33,100.43,2.42,191.56-28,286-24.58,76.32,39.98,83.65,62,183,21.5,97-19.19,146.29-92,263-82.89,132.88,28.48,299.6,48.99,353.1,43.55,113.61,23.3,224.91-42.99,347.9-66.29,122.99,27,190.21,27,190.21l-143-1V0L151,3Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBadgesPathwayBackgroundLeft26, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BadgesPathwayBackground_Left26.742214a1.svg";
export { ForwardRef as ReactComponent };